/* istanbul ignore file */
import Chip, { ChipProps } from '@mui/material/Chip';
import { BadgeLayoutProps } from 'framework/ui/uiContract/uiContract';

export type BadgeProps = BadgeLayoutProps & Pick<ChipProps, 'title' | 'variant' | 'clickable' | 'aria-pressed'>;

const Badge = ({ children, isVisible = true, color, sx = {}, ...props }: BadgeProps) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Chip
      sx={{
        marginLeft: '2px',
        fontSize: '12px',
        lineHeight: '1',
        height: 'auto',
        borderRadius: 1,

        '& .MuiChip-label': {
          padding: '4px 8px',
        },
        ...sx,
      }}
      {...props}
      label={children}
      color={color}
    />
  );
};

export default Badge;
